import { createContext, useCallback, useState } from 'react';

import { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';

interface ProceedGuardResult {
  blocked: boolean;
  message: string;
  header: string;
}

interface MapInteractionContextOptions {
  geometry: GeoJSONFeatureCollection | undefined;
  onProceed: (featureCollection: GeoJSONFeatureCollection) => void;
  onProceedGuard?: (featureCollection: GeoJSONFeatureCollection) => ProceedGuardResult;
}

interface Context {
  unsetInteractionOptions: () => void;
  setInteractionOptions: (options: MapInteractionContextOptions) => void;
  interactionOptions: MapInteractionContextOptions;
}

export const MapInteractionContext = createContext<Context | undefined>(undefined);

export const MapInteractionContextProvider = (props: any) => {
  const [interactionOptions, setInteractionOptions] = useState<MapInteractionContextOptions | undefined>(undefined);

  const unsetInteractionOptions = useCallback(() => {
    setInteractionOptions(undefined);
  }, [setInteractionOptions]);

  return (
    <MapInteractionContext.Provider
      value={{ unsetInteractionOptions, setInteractionOptions, interactionOptions }}
      {...props}
    >
      {props.children}
    </MapInteractionContext.Provider>
  );
};
